interface GearInsideCircleSVGProps {
  color: string;
  style: React.CSSProperties;
}

const GearInsideCircleSVG = ({ color, style }: GearInsideCircleSVGProps) => (
  <svg
    style={style}
    xmlns="http://www.w3.org/2000/svg"
    width="38"
    height="32"
    viewBox="0 0 38 32"
    fill="none"
  >
    <g clipPath="url(#clip0_519_20342)">
      <path
        d="M30.9824 16L33.7969 19.3002L37.0971 16.4858"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.53092 19.3622L3.18441 16.6172L0.431641 19.9637"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.29248 12.5222C4.8732 5.59791 11.065 0.431641 18.4674 0.431641C25.8698 0.431641 32.4703 5.94489 33.7889 13.2085"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M32.4782 22.8006C29.9567 27.99 24.6285 31.5678 18.4676 31.5678C12.3066 31.5678 6.8242 27.882 4.34131 22.5615"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19 19C20.6569 19 22 17.6569 22 16C22 14.3431 20.6569 13 19 13C17.3431 13 16 14.3431 16 16C16 17.6569 17.3431 19 19 19Z"
        stroke={color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
      <path
        d="M25.8781 13.5486L26.1865 13.2324L24.8757 10.9655L24.4439 11.0734C23.5648 11.2893 22.6395 11.1428 21.8608 10.6879C21.853 10.6879 21.8453 10.6802 21.8376 10.6724C21.0511 10.2175 20.4497 9.49269 20.2029 8.62136L20.0795 8.19727H17.4579L17.3345 8.62136C17.08 9.49269 16.4863 10.2175 15.6998 10.6647C15.6998 10.6647 15.6921 10.6647 15.6844 10.6647C15.6844 10.6647 15.6767 10.6647 15.6689 10.6647C14.8824 11.1197 13.9571 11.2739 13.0781 11.058L12.6463 10.95L11.3354 13.217L11.6439 13.5332C12.2762 14.1886 12.6 15.0676 12.6 15.9775C12.6 15.9852 12.6 16.0006 12.6 16.0084C12.6 16.9105 12.2685 17.7896 11.6439 18.4373L11.3354 18.7534L12.6463 21.0204L13.0781 20.9124C13.9571 20.6965 14.8824 20.8431 15.6612 21.298C15.6689 21.298 15.6767 21.3057 15.6844 21.3134C16.4709 21.7683 17.0723 22.4932 17.3191 23.3645L17.4424 23.7886H20.0641L20.1875 23.3645C20.442 22.4932 21.0357 21.7684 21.8222 21.3211C21.8222 21.3211 21.8299 21.3211 21.8376 21.3211C21.8453 21.3211 21.8453 21.3211 21.853 21.3211C22.6395 20.8662 23.5648 20.712 24.4439 20.9279L24.8757 21.0358L26.1865 18.7688L25.8781 18.4527C25.2458 17.7973 24.922 16.9182 24.922 16.0084V15.9775C24.922 15.0753 25.2535 14.1963 25.8781 13.5486Z"
        stroke={color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_519_20342">
        <rect width="37.5287" height="32" fill={color} />
      </clipPath>
    </defs>
  </svg>
);

export default GearInsideCircleSVG;
